import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Fab } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import Homepage from "./componets/pages/home/layouts/HomePage";
import Popup from "./componets/pages/home/componets/PopUp";
import ApplyPopUp from "./componets/pages/home/componets/ApplyPopUp";
import ThankYouPage from "./componets/pages/home/componets/ThankyouPage";
import PrivacyPolicy from "./componets/pages/home/layouts/PrivacyPolicy";
import TermsConditions from "./componets/pages/home/layouts/TermsConditions";
import AboutUs from "./componets/pages/home/componets/AboutUs";
import Courses from "./componets/pages/home/componets/Courses";
import Acheivements from "./componets/pages/home/componets/Acheivements";
import Facilities from "./componets/pages/home/componets/Facilities";
import Gallary from "./componets/pages/home/layouts/Gallary";
import Contact from "./componets/pages/home/layouts/Contact";
import NewsHeader from "./componets/pages/home/componets/NewsHeader";
import Header from "./componets/pages/home/componets/Header";
import Footer from "./componets/pages/home/componets/Footer";
import SummerCamp from "./componets/pages/home/componets/SumerCamp";
import BreadCrumb from "./componets/pages/home/componets/BreadCrumb";
import InfoPage from "./componets/pages/home/componets/InfoPage";
import Blogs from "./componets/pages/home/layouts/Blogs";
import BlogDetail from "./componets/pages/home/layouts/BlogDetail";

const App = () => {
  const [open, setOpen] = useState(false);
  const [isApplyButton, setIsApplyButton] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const isFormSubmit = localStorage.getItem("isFormSubmited");

  useEffect(() => {
    if (!isFormSubmit) {
      const handleOpen = () => {
        if (!open) {
          setOpen(true);
        }
      };
      const interval = setInterval(handleOpen, 10000);
      return () => clearInterval(interval);
    }
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleOpenModal = () => {
    setIsApplyButton(true);
    setOpen(true);
  };
  useEffect(() => {
    if (!isFormSubmit) {
      const handleOpen = () => {
        if (!open) {
          setOpen(true);
        }
      };
      const interval = setInterval(handleOpen, 10000);
      return () => clearInterval(interval);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Homepage
              onApplyNowClick={handleOpenModal}
              isApplyButton={isApplyButton}
            />
          }
        />
        <Route path="/about" element={<><NewsHeader /><Header /><BreadCrumb title={'About Podar Juniors'}/><InfoPage /><AboutUs /><Footer /></>} />
        <Route path="/summer" element={<><NewsHeader /><Header /><BreadCrumb title={'Summer Camp'}/><SummerCamp /><Footer /></>} />
        <Route path="/courses" element={<><NewsHeader /><Header /><BreadCrumb title={'Courses'}/><Courses /><Footer /></>} />
        <Route path="/achievements" element={<><NewsHeader /><Header /><BreadCrumb title={'Our Achievements'}/><Acheivements /><Footer /></>} />
        <Route path="/facilities" element={<><NewsHeader /><Header /><BreadCrumb title={'Our Facilities'}/><Facilities /><Footer /></>} />
        <Route path="/gallary" element={<><NewsHeader /><Header /><BreadCrumb title={'Our Gallary'}/><Gallary /><Footer /></>} />
        <Route path="/contact" element={<><NewsHeader /><Header /><BreadCrumb title={'Contact Us'}/><Contact /><Footer /></>} />
        {/* <Route path="/blogs" element={<><NewsHeader /><Header /><BreadCrumb title={'Our Blogs'}/><Blogs /><Footer /></>} /> */}
        {/* <Route path="/blog-detail/:link" element={<><NewsHeader /><Header /><BlogDetail /><Footer /></>} /> */}
        <Route path="/applypopup" element={<ApplyPopUp />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
      </Routes>
      <Popup open={open} onClose={handleClose} />

      {showScroll && (
        <Fab
          onClick={handleScrollToTop}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            backgroundColor: showScroll ? "#1d67ab" : "white", // Border color fills on scroll
            border: "2px solid #1d67ab",
            color: showScroll ? "white" : "black", // Icon turns white when scrolled
            transition: "all 0.3s ease-in-out", // Smooth transition effect
            "&:hover": {
              backgroundColor: "#fdce0d", // Keep border filled when hovered
              color: "black",
              border: "2px solid #fdce0d",
            },
            boxShadow: 3,
          }}
        >
          <ArrowUpwardRoundedIcon />
        </Fab>
      )}
    </BrowserRouter>
  );
};

export default App;

